import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CheckboxButton } from '@cian/ui-kit';
import { promosApplyChipsRequestAction } from '../../actions/chips';
import { Chip } from '../../components/Chip';
import { ChipsLayout } from '../../components/ChipsLayout';
import { selectChips } from '../../selectors/chips';
import { selectIsCompilation } from '../../selectors/compilation';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { TThunkDispatch } from '../../types/redux/thunk';

export const ChipsContainer: React.FC = () => {
  const dispatch: TThunkDispatch = useDispatch();
  const chips = useSelector(selectChips);
  const isCompilation = useSelector(selectIsCompilation);

  const handleChange = React.useCallback(
    (jsonQuery: IJsonQuery, isActive: boolean) => () => {
      dispatch(promosApplyChipsRequestAction(jsonQuery, isActive));
    },
    [],
  );

  if (isCompilation) {
    return null;
  }

  return (
    <ChipsLayout>
      {chips.map(item => {
        return (
          <Chip key={item.name}>
            <CheckboxButton
              label={item.name}
              onChange={handleChange(item.jsonQuery, item.isActive)}
              checked={item.isActive}
              size="M"
            />
          </Chip>
        );
      })}
    </ChipsLayout>
  );
};
